/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that they will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, { Children, Component } from 'react';
import { themeable } from '@instructure/ui-themeable';
import { Children as ChildrenPropType } from '@instructure/ui-prop-types';
import { Pill } from '@instructure/ui-elements';
const styles = {
  componentId: 'WWGvl',
  template: function template(theme) {
    return "\n\n.BadgeList-styles__root {\n  line-height: ".concat(theme.lineHeight || 'inherit', ";\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  text-align: inherit;\n}\n\n[dir=\"ltr\"] .BadgeList-styles__root {\n  text-align: inherit;\n}\n\n[dir=\"rtl\"] .BadgeList-styles__root {\n  text-align: inherit;\n}\n\n.BadgeList-styles__item {\n  display: inline-block;\n  vertical-align: middle;\n  margin: ").concat(theme.itemMargin || 'inherit', ";\n}\n");
  },
  'root': 'BadgeList-styles__root',
  'item': 'BadgeList-styles__item'
};
import theme from './theme.js';

class BadgeList extends Component {
  renderChildren() {
    return Children.map(this.props.children, child => {
      return React.createElement("li", {
        key: child.key,
        className: styles.item
      }, child);
    });
  }

  render() {
    return React.createElement("ul", {
      className: styles.root
    }, this.renderChildren());
  }

}

BadgeList.propTypes = {
  children: ChildrenPropType.oneOf([Pill])
};
export default themeable(theme, styles)(BadgeList);